module.exports = __webpack_public_path__ + "img/htEvent_introduce_banner_cn.561d3fc8.jpg";